import { odds as fmt } from './format';
import { cx } from './cx';
import s from './ui.module.scss';

/**
 * La cote du palier atteint.
 *
 * C'est le chiffre le plus important de l'ecran : c'est lui qui transforme
 * « j'attends encore un peu » en decision couteuse. Il est donc enorme, et il
 * S'ECRASE a chaque changement de palier — une mauvaise nouvelle doit se voir
 * meme quand on lisait l'indice.
 *
 * Le client ne connait PAS le calendrier des paliers : le serveur n'envoie que
 * la cote courante. On n'affiche donc aucun compte a rebours vers la chute
 * suivante, et c'est honnete — inventer une echeance qu'on ne connait pas
 * serait pire que de ne rien dire.
 */
export interface OddsBadgeProps {
  value: number;
  /** Change a chaque palier : c'est lui qui rejoue l'animation de chute. */
  stageToken: number;
  /** Ce que la mise rapporterait a cette cote, si on la connait. */
  potential?: number | undefined;
}

export function OddsBadge({ value, stageToken, potential }: OddsBadgeProps) {
  return (
    <div className={s.odds}>
      <span className={s.oddsLabel}>Cote</span>
      {/* La cle force React a recreer l'element : sans ca, une animation deja
          jouee ne repart pas au palier suivant. */}
      <span key={stageToken} className={cx(s.oddsValue, s.oddsSlam)}>
        {fmt(value)}
      </span>
      {potential !== undefined ? (
        <span className={s.oddsPotential}>+{Math.round(potential)} si juste</span>
      ) : null}
    </div>
  );
}
